var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6461 1.05313L16.0861 2.49312L11.2061 7.37313L7.91608 4.08313C7.72925 3.89587 7.4756 3.79064 7.21108 3.79064C6.94657 3.79064 6.69292 3.89587 6.50608 4.08313L0.506085 10.0931C0.116085 10.4831 0.116085 11.1131 0.506085 11.5031C0.896085 11.8931 1.52608 11.8931 1.91608 11.5031L7.20608 6.20312L10.4961 9.49312C10.8861 9.88313 11.5161 9.88313 11.9061 9.49312L17.4961 3.91313L18.9361 5.35313C19.2461 5.66313 19.7861 5.44313 19.7861 5.00313V0.703125C19.7961 0.423125 19.5761 0.203125 19.2961 0.203125H15.0061C14.5561 0.203125 14.3361 0.743125 14.6461 1.05313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard);
export default __webpack_public_path__ + "static/media/icon-leaderboard.9ef26fcf97043f92dafd653697e332ac.svg";
export { ForwardRef as ReactComponent };